<template>
  <tr>
    <td>
      <router-link :to="`/products/${stockRotation.accumulated_id}`">
        {{ stockRotation.name }}
        <span v-if="viewType !== 'product' && stockRotation.product_instance.product.is_variation_of">({{ stockRotation.product_instance.product.stringRepShort.join(' | ') }})</span>
      </router-link>
    </td>
    <td class="text-right">{{ stockRotation.quantity_sold }}</td>
    <td class="text-right">{{ (stockRotation.sum_price_sold / stockRotation.quantity_sold) | priceFromCentEuro }}</td>
    <td class="text-right">{{ (stockRotation.cheapestSupplier || stockRotation.product_instance.product.standard_price) | priceFromCentEuro }}</td>
    <td class="text-right">{{ getUmsatz(stockRotation)  | priceFromCentEuro }}</td>
    <td class="text-right">{{ getPreis(stockRotation)  | priceFromCentEuro }}</td>
    <td class="text-right">
      <strong>{{ getDb(stockRotation) | priceFromCentZeroEuro  }}</strong>
    </td>
    <td v-if="viewType === 'product'" class="text-center">
      <a href="#" @click.prevent="$emit('openVariations', stockRotation)">
        <i class="fas fa-boxes" aria-hidden="true"></i>
      </a>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['stockRotation', 'getDb', 'getUmsatz', 'getPreis', 'viewType'],
  data () {
    return {
    }
  }
}
</script>
